// main.js
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import cx from 'classnames';
import UI from 'UI';
import PropTypes from 'prop-types';
import RCore from 'RCore';
import Eventify from 'Eventify';
import tournamentsTranslations from '../../helpers/i18.tournaments';

var i18dict = {
    en: {
        round: 'Round {0}',
        'finished.short': 'FT',
        'cancelled.short': 'CAN',
        'postponed.short': 'POST',
        halftime: 'HT',
        live: "LIVE {0}'",
        finished: 'Finished',
        cancelled: 'Cancelled',
        postponed: 'Postponed',
    },
    da: {
        round: 'Runde {0}',
        'finished.short': 'SLUT',
        'cancelled.short': 'CAN',
        'postponed.short': 'UDSAT',
        halftime: 'HT',
        live: "LIVE {0}'",
        finished: 'SLUT',
        cancelled: 'Aflyst',
        postponed: 'Udsat',
    },
};
class EventCell extends React.Component {
    static defaultProps = {
        event: {
            homeName: '\u00a0',
            awayName: '\u00a0',
            score: {
                home: '-',
                away: '-',
            },
            properties: {},
        },
        showBroadcast: false,
        statusShort: false,
    };

    static contextTypes = {
        info: PropTypes.object,
        screenSizeObserver: PropTypes.object,
        teamLogoSettings: PropTypes.object,
        moment: PropTypes.func,
        eventCellView: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = {};
        this.i18 = RCore.i18.bind(this);
        this.i18dict = i18dict;
    }

    getSSSafe() {
        if (!this.context.screenSizeObserver) return 'sm';
        return this.context.screenSizeObserver.getSS();
    }

    renderBroadcast() {
        const { event } = this.props;
        return (
            <div className="wdp-event-cell__broadcast">
                <img src={event.channel.logoUrl} />
            </div>
        );
    }

    renderStub() {
        const showTeamLogo =
            (this.context.teamLogoSettings && this.context.teamLogoSettings.display != 'none') ||
            !_.isEmpty(this.props.teamLogo);
        return (
            <div
                className={cx('wdp-event-cell', `wdp-event-cell__stub`, `wdp-event-cell__notstarted`, {
                    'wdp-event-cell__with-logo': showTeamLogo,
                })}
            >
                <div className="wdp-event-cell__score">
                    <div className="wdp-event-cell__row wdp-event-cell__home">
                        <span className="wdp-event-cell__team-score">-</span>
                    </div>
                    <div className="wdp-event-cell__row wdp-event-cell__away">
                        <span className="wdp-event-cell__team-score">-</span>
                    </div>
                    <span className="wdp-event-cell__status" />
                </div>
                <div className="wdp-event-cell__main">
                    <div className="wdp-event-cell__info">{UI.nbsp}</div>
                    <div className="wdp-event-cell__row wdp-event-cell__home">
                        {showTeamLogo && false && <UI.TeamLogo size="small" tournamentId={tournament.id} />}
                        {UI.nbsp}
                    </div>
                    <div className="wdp-event-cell__row wdp-event-cell__away">
                        {showTeamLogo && false && <UI.TeamLogo size="small" tournamentId={tournament.id} />}
                        {UI.nbsp}
                    </div>
                </div>
            </div>
        );
    }

    renderExtraContent() {
        return null;
    }

    getPreliveStatus(event) {
        return this.context.moment(event.startDate).format('HH:mm');
    }

    getEventStatus = (event, screenSize) => {
        let status = null;
        if (!event) return null;

        const live = event.isLive();
        const ht = event.isHT();
        const coming = event.isComing();
        const finished = event.isFinished();
        const cancelled = event.isCancelled();
        const postponed = event.isPostponed();

        if (live && ht) status = this.i18('halftime');
        else if (live && !ht) status = this.i18('live', event.getMinutes());
        else if (coming) status = this.getPreliveStatus(event);
        else if ((cancelled || finished || postponed) && !coming && screenSize == 'xs')
            status = this.i18(`${event.statusType}.short`);
        else status = this.i18(event.statusType);

        return status;
    };

    renderCellStatus(event, screenSize) {
        // let live        = event.isLive();
        // let ht          = event.isHT();
        const coming = event.isComing();
        // let finished    = event.isFinished();
        // let cancelled   = event.isCancelled();
        // let postponed   = event.isPostponed();

        return (
            <div className="wdp-event-cell__score">
                <div className="wdp-event-cell__row wdp-event-cell__home">
                    <span className="wdp-event-cell__team-score">{coming ? '-' : _.get(event, 'score.home', 0)}</span>
                </div>
                <div className="wdp-event-cell__row wdp-event-cell__away">
                    <span className="wdp-event-cell__team-score">{coming ? '-' : _.get(event, 'score.away', 0)}</span>
                </div>
                <span className="wdp-event-cell__status">{this.getEventStatus(event, screenSize)}</span>
            </div>
        );
    }

    renderCellInfo(event, screenSize, withStatus) {
        const { statusShort } = this.props;
        const lang = this.context.info.lang;
        const tournamentName = _.get(
            tournamentsTranslations,
            `${lang}.${event.tournamentTemplateId}`,
            event.tournamentName,
        );

        return (
            <div className="wdp-event-cell__info">
                {_.compact([
                    !statusShort && (
                        <span key="s0">
                            <UI.TournamentName
                                id={event.tournamentTemplateId}
                                client={this.context.info.client}
                                name={tournamentName}
                            />
                        </span>
                    ),
                    !statusShort && <span key="s1">-</span>,
                    event.tournamentTemplateId !== 489 && event.properties && (
                        <span key="s2">{this.i18('round', event.properties.round)}</span>
                    ),
                    event.tournamentTemplateId !== 489 && event.properties && <span key="s3">-</span>,
                    <span key="s4">
                        {this.context
                            .moment(event.startDate)
                            .format(screenSize === 'xs' ? 'DD MMM YY' : 'DD MMMM YYYY')}
                    </span>,
                    withStatus && <span key="s5">-</span>,
                    withStatus && <span key="s6">{this.getEventStatus(event, screenSize)}</span>,
                ])}
            </div>
        );
    }

    renderCompactCell = () => {
        let { showBroadcast, linksDisabled, lang, event = EventCell.defaultProps.event } = this.props;
        const showTeamLogo =
            (this.context.teamLogoSettings && this.context.teamLogoSettings.display !== 'none') ||
            !_.isEmpty(this.props.teamLogo);
        event = Eventify(event);
        const coming = event.isComing();

        // var screenSize = this.context.screenSizeObserver.screenSize
        var screenSize = this.props.screenSize || this.getSSSafe();
        let { homeName, awayName } = event;
        switch (screenSize) {
            case 'xs': {
                homeName = event.homeShortName || homeName;
                awayName = event.awayShortName || awayName;
                break;
            }
            case 'sm':
            case 'md':
            case 'lg':
        }
        return (
            <UI.Link
                action="event"
                withParams={event}
                className={cx('wdp-event-cell', 'wdp-event-cell__line-view', `wdp-event-cell__${event.statusType}`, {
                    'wdp-event-cell__with-logo': showTeamLogo,
                })}
                disabled={linksDisabled}
                key={`${event.eventId}_compact`}
            >
                <div className="wdp-event-cell__main">
                    <div className="wdp-event-cell__home wdp-event-cell__team-name">
                        <span className="wdp-event-cell__name">{homeName}</span>
                        {showTeamLogo && <UI.TeamLogo teamId={event.homeId} size="small" />}
                    </div>
                    <div className="wdp-event-cell__score">
                        <span className="wdp-event-cell__home-score wdp-event-cell__team-score">
                            {coming ? '-' : _.get(event, 'score.home', 0)}
                        </span>
                        <span className="wdp-event-cell__score-divider">:</span>
                        <span className="wdp-event-cell__away-score wdp-event-cell__team-score">
                            {coming ? '-' : _.get(event, 'score.away', 0)}
                        </span>
                    </div>
                    <div className="wdp-event-cell__away wdp-event-cell__team-name">
                        {showTeamLogo && <UI.TeamLogo teamId={event.awayId} size="small" />}
                        <span className="wdp-event-cell__name">{awayName}</span>
                    </div>
                </div>
                {this.renderCellInfo(event, screenSize, true)}
            </UI.Link>
        );
    };

    renderCompactV2Cell = () => {
        let { showBroadcast, linksDisabled, lang, event = EventCell.defaultProps.event } = this.props;
        const showTeamLogo =
            (this.context.teamLogoSettings && this.context.teamLogoSettings.display !== 'none') ||
            !_.isEmpty(this.props.teamLogo);
        event = Eventify(event);
        const coming = event.isComing();

        // var screenSize = this.context.screenSizeObserver.screenSize
        var screenSize = this.props.screenSize || this.getSSSafe();
        let { homeName, awayName } = event;
        switch (screenSize) {
            case 'xs': {
                homeName = event.homeShortName || homeName;
                awayName = event.awayShortName || awayName;
                break;
            }
            case 'sm':
            case 'md':
            case 'lg':
        }

        return (
            <UI.Link
                action="event"
                withParams={event}
                key={`${event.eventId}_v2_compact`}
                className={cx('wdp-ecell', 'wdp-ecell__compact-v2', `wdp-ecell__compact-v2__${event.statusType}`, {
                    'wdp-event-cell__with-logo': showTeamLogo,
                    'wdp-ecell__stub': event.stub,
                })}
                disabled={linksDisabled}
            >
                {event.isComing() && (
                    <div className="wdp-ecell__info">{this.context.moment(event.startDate).format('dddd, D MMMM')}</div>
                )}
                {event.isLive() && (
                    <div className="wdp-ecell__info wdp-ecell__info__live">
                        LIVE {event.isHT() ? this.i18('halftime') : event.getMinutes()}
                    </div>
                )}

                <div className="wdp-ecell__main">
                    <div className="wdp-ecell__team wdp-ecell__team__home">
                        <span className="wdp-event-cell__name">{homeName}</span>
                        {showTeamLogo && (
                            <span className="wdp-event-cell__team_logo">
                                <UI.TeamLogo teamId={event.homeId} size="small" />
                            </span>
                        )}
                    </div>
                    <div className="wdp-ecell__score">
                        {!event.stub && coming && this.context.moment(event.startDate).format('HH:mm')}
                        {!event.stub &&
                            !coming &&
                            _.get(event, 'score.home', 0) + ' - ' + _.get(event, 'score.away', 0)}
                        {event.stub && '-'}
                    </div>
                    <div className="wdp-ecell__team wdp-ecell__team__away">
                        {showTeamLogo && (
                            <span className="wdp-event-cell__team_logo">
                                <UI.TeamLogo teamId={event.awayId} size="small" />
                            </span>
                        )}
                        <span className="wdp-event-cell__name">{awayName}</span>
                    </div>
                </div>
                {(event.isComing() || event.isLive()) && event.channel && event.channel.logoUrl && (
                    <div className="wdp-ecell__tv-broadcast">
                        <img height="18px" src={event.channel.logoUrl} />
                    </div>
                )}
            </UI.Link>
        );
    };

    render() {
        let { showBroadcast, linksDisabled, lang, event = EventCell.defaultProps.event } = this.props;
        let { homeName, awayName } = event;
        const showTeamLogo =
            (this.context.teamLogoSettings && this.context.teamLogoSettings.display !== 'none') ||
            !_.isEmpty(this.props.teamLogo);
        const eventCellView = this.props.display || _.get(this.context, 'eventCellView.display', 'default');
        event = Eventify(event);

        // var screenSize = this.context.screenSizeObserver.screenSize
        var screenSize = this.props.screenSize || this.getSSSafe();

        switch (screenSize) {
            case 'xs': {
                homeName = event.homeShortName || homeName;
                awayName = event.awayShortName || awayName;
                break;
            }
            case 'sm':
            case 'md':
            case 'lg':
        }

        if (eventCellView === 'compact') {
            return this.renderCompactCell();
        } else if (eventCellView === 'compact_v2') {
            return this.renderCompactV2Cell();
        }
        // render stub for loading
        if (event.stub === true) return this.renderStub();

        return (
            <UI.Link
                action="event"
                withParams={event}
                key={`${event.eventId}_normal`}
                className={cx('wdp-event-cell', `wdp-event-cell__${event.statusType}`, {
                    'wdp-event-cell__with-logo': showTeamLogo,
                })}
                disabled={linksDisabled}
            >
                {this.renderCellStatus(event, screenSize)}
                <div className="wdp-event-cell__main">
                    {this.renderCellInfo(event, screenSize)}

                    <div className="wdp-event-cell__row wdp-event-cell__home">
                        {showTeamLogo && <UI.TeamLogo teamId={event.homeId} size="small" />}
                        <span className="wdp-event-cell__team-name">{homeName}</span>
                    </div>
                    <div className="wdp-event-cell__row wdp-event-cell__away">
                        {showTeamLogo && <UI.TeamLogo teamId={event.awayId} size="small" />}
                        <span className="wdp-event-cell__team-name">{awayName}</span>
                    </div>
                </div>
                {showBroadcast && event.channel && this.renderBroadcast()}
                {this.renderExtraContent(event)}
            </UI.Link>
        );
    }
}

EventCell.spec = {
    propType: {
        defaultValue: 'default',
        key: 'eventCellView',
        type: 'select_picker',
        label: 'Event cell view',
        options: [
            {
                text: 'Default',
                value: 'default',
            },
            {
                text: 'Compact',
                value: 'compact',
            },
            {
                text: 'Compact V2',
                value: 'compact_v2',
            },
        ],
    },
};

export default EventCell;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/EventCell.js
 **/